import root from './_root.js';

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

export default Uint8Array;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_Uint8Array.js
// module id = 1035
// module chunks = 3